import {type LayoutMode} from '../common';
import {compareModeConfig} from './compareMode';
import {galleryModeConfig} from './galleryMode';
import {gridModeConfig} from './gridMode';
import {type MediaPanelModeConfig} from './types';

/**
 * Avoid tons of if/else statements by using configs for each mode.
 * This helps with readability as well as making new modes easier to add.
 */
export function getModeConfig(
  mode: LayoutMode | undefined
): MediaPanelModeConfig {
  if (mode === undefined) {
    return galleryModeConfig;
  }
  switch (mode) {
    case 'gallery':
      return galleryModeConfig;
    case 'grid':
      return gridModeConfig;
    case 'compare':
      return compareModeConfig;
  }
}
